import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

type TypeIconData = {
  className: string
  label: string
}

interface IconProps {
  type: HitType
}

export default function Icon({ type }: IconProps) {
  const { t } = useTranslation()

  const iconMap = useMemo(() => {
    const map = new Map<HitType, TypeIconData>()
    map.set('lvl0', {
      className: 'far fa-file',
      label: t('search.resultType.page'),
    })
    map.set('lvl1', {
      className: 'fas fa-hashtag',
      label: t('search.resultType.heading'),
    })
    map.set('lvl2', {
      className: 'fas fa-hashtag',
      label: t('search.resultType.heading'),
    })
    map.set('lvl3', {
      className: 'fas fa-hashtag',
      label: t('search.resultType.heading'),
    })
    map.set('lvl4', {
      className: 'fas fa-hashtag',
      label: t('search.resultType.heading'),
    })
    map.set('lvl5', {
      className: 'fas fa-hashtag',
      label: t('search.resultType.heading'),
    })
    map.set('lvl6', {
      className: 'fas fa-hashtag',
      label: t('search.resultType.heading'),
    })
    map.set('content', {
      className: 'fas fa-bars',
      label: t('search.resultType.content'),
    })
    return map
  }, [t])

  const iconData = iconMap.get(type)

  if (!iconData) {
    return null
  }

  return (
    <span>
      <i className={iconData.className} aria-hidden={true}></i>
      <span className="Offscreen">{`${t('search.resultTypeLabel')}: ${
        iconData.label
      }`}</span>
    </span>
  )
}
